import React from "react";
import { SchoolWithExamRegistration } from "../../types/types";

interface RegistrationNoticeProps {
  registrationData: SchoolWithExamRegistration | null;
}

const RegistrationNotice: React.FC<RegistrationNoticeProps> = ({
  registrationData,
}) => {
  return (
    <div className="gceo-registration-notice">
      <p className="gceo-notice-text">
        Payment <strong>MUST</strong> be made{" "}
        <strong>
          before{" "}
          {registrationData?.exam_session
            ? new Date(
                registrationData.exam_session.registration_deadline
              ).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })
            : "14th February 2026"}
        </strong>{" "}
        in order to avoid problems associated with production. Register online
        at <strong>https://trunorthwest.net</strong> before the deadline as
        forfeit the 16%. Irregular declaration of the total No. of candidates
        will cause review of the payments made.
      </p>
    </div>
  );
};

export default RegistrationNotice;
